import { render, staticRenderFns } from "./DeductBonusModal.vue?vue&type=template&id=5c7d10ba&"
import script from "./DeductBonusModal.vue?vue&type=script&lang=js&"
export * from "./DeductBonusModal.vue?vue&type=script&lang=js&"
import style0 from "./DeductBonusModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports